export const PropertyTypes = {
    string: "string",
    bool: "bool",
    dateTime: "dateTime",
    dateOnly: "dateOnly",
    selectByEntityName: "selectByEntityName",
    address: 'address',
    contactDetails: 'contactDetails',
    email: 'email',
    selectRole: "selectRole",
    number: "number",
    textArea: "textArea",
    range: "range",
    fileUpload: "fileUpload",
    year: "year",
    uuid: "uuid",
    code: "code",
    int: "int",
    intNullable: "intNullable",
    guidList: "guidList",
    CaseMaterialStatus: "caseMaterialStatus",
    breadcrumb: "breadcrumb",
    status: "status",
    entity: "entity",
    belongsToCellTrak: "belongsToCellTrak",
    entityName: "entityName",
    accountRoles: "accountRoles",
    computed: "computed",
    PackingBoxType: "PackingBoxType",
    volume: "volume",
    owner: "owner",
    percentage: "percentage",
    quantity: "quantity",
    specimens: "specimens",
    download: "download",
    readonlyString: "readonlyString",
    hidden: "hidden",
    accountPrefix: "accountPrefix",
    disposalYears: "disposalYears",
    vNumberStandardSize: "vNumberStandardSize"
}